import { AutocompleteWidget, AUTOCOMPLETE_WIDGET } from './AutocompleteWidget/AutocompleteWidget';
import { ChartWidget, CHART_WIDGET } from './ChartWidget/ChartWidget';
import { ITEMS_SELECTION_WIDGET, ItemsSelectionWidget } from './ItemsSelectionWidget/ItemsSelectionWidget';
import { MULTI_SELECT_WIDGET, MultiSelectWidget } from './MultiSelectWidget/MultiSelectWidget';
import { PLANS_WIDGET, PlansWidget } from './PlansWidget/PlansWidget';
import { PREMIUM_UPSELL_WIDGET, PremiumUpsellWidget } from './PremiumUpsellWidget/PremiumUpsellWidget';
import { RADIO_BUTTON_WIDGET, RadioButtonWidget } from './RadioButtonWidget/RadioButtonWidget';
import { SINGLE_SELECT_BUTTON_WIDGET, SingleSelectButtonWidget } from './SingleSelectButtonWidget/SingleSelectButtonWidget';
import { SINGLE_SELECT_WIDGET, SingleSelectWidget } from './SingleSelectWidget/SingleSelectWidget';
import { VISUAL_DISPLAY_WIDGET, VisualDisplayWidget } from './VisualDisplayWidget/VisualDisplayWidget';
import { LIQUID_WIDGET, LiquidWidget } from './LiquidWidget/LiquidWidget';
export const commonWidgets = {
  data: {
    [AUTOCOMPLETE_WIDGET]: [AUTOCOMPLETE_WIDGET, AutocompleteWidget],
    [CHART_WIDGET]: [CHART_WIDGET, ChartWidget],
    [MULTI_SELECT_WIDGET]: [MULTI_SELECT_WIDGET, MultiSelectWidget],
    [PLANS_WIDGET]: [PLANS_WIDGET, PlansWidget],
    [PREMIUM_UPSELL_WIDGET]: [PREMIUM_UPSELL_WIDGET, PremiumUpsellWidget],
    [RADIO_BUTTON_WIDGET]: [RADIO_BUTTON_WIDGET, RadioButtonWidget],
    [SINGLE_SELECT_BUTTON_WIDGET]: [SINGLE_SELECT_BUTTON_WIDGET, SingleSelectButtonWidget],
    [SINGLE_SELECT_WIDGET]: [SINGLE_SELECT_WIDGET, SingleSelectWidget],
    [VISUAL_DISPLAY_WIDGET]: [VISUAL_DISPLAY_WIDGET, VisualDisplayWidget],
    [ITEMS_SELECTION_WIDGET]: [ITEMS_SELECTION_WIDGET, ItemsSelectionWidget],
    [LIQUID_WIDGET]: [LIQUID_WIDGET, LiquidWidget]
  },
  getNames() {
    return Object.keys(this.data);
  },
  getComponents() {
    return Object.values(this.data);
  }
};
//# sourceMappingURL=index.js.map